import { Container } from "@/components/atoms";
import { CompaniesAddPanel, PageHeader, PageHeaderV2 } from "@/components/organisms";

export const CompaniesAdd = () => {
  return (
    <Container className="mb-12 flex w-full flex-1 flex-col">
      <PageHeaderV2 name="Companies" skipCrumbs={1} />
      <PageHeader.Actions />
      <CompaniesAddPanel />
    </Container>
  );
};
